// 5.42.0 ACORD deep links survive a sign-in. ACORD sends a signed-out or expired visitor to /?next=<the ACORD address>
// (e.g. /?next=%2Facord%2F%3Fcarrier%3D12); after signing in here, InsureDocs goes back to that exact address.
// Only this site's /acord/ pages are honoured — anything else (another site, //host, javascript:, other paths) is
// ignored, so the parameter can't be used to send someone elsewhere.
export function safeNext(search, origin) {
  let raw;
  try { raw = new URLSearchParams(search || '').get('next'); } catch (_e) { return null; }
  if (!raw || raw.length > 2000 || !raw.startsWith('/acord/') || /[\\\s]/.test(raw)) return null;
  try {
    const base = origin || window.location.origin;
    const u = new URL(raw, base);
    if (u.origin !== new URL(base).origin || !u.pathname.startsWith('/acord/')) return null;
    return u.pathname + u.search + u.hash;
  } catch (_e) {
    return null;
  }
}
